import cuid from "cuid";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { BiCheck, BiChevronLeft } from "react-icons/bi";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import CoverageBenefitsList from "./CoverageBenefits";
import validation from "./validation";

const Detail = ({ onSubmit, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.COVERAGE);
  const CREATE = t("CREATE", { returnObjects: true });

  return (
    <>
      <Formik
        initialValues={{
          coverageBenefits: [{ id: cuid() }],
        }}
        onSubmit={onSubmit}
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
        )}
      >
        {({ handleSubmit, ...formProps }) => [
          <Header
            key={"header"}
            title={CREATE.HEADER.TITLE}
            subtitle={CREATE.HEADER.ACTION}
            actions={[
              {
                text: CREATE.HEADER.DISCARD,
                onClick: cancel,
                type: "primary--outlined",
                icon: <BiChevronLeft size={20} />,
              },
              {
                text: CREATE.HEADER.SAVE,
                onClick: handleSubmit,
                type: "primary",
                icon: <BiCheck size={20} />,
              },
            ]}
          />,
          <div key="coverage" className="coverage-container">
            <CoverageBenefitsList formProps={formProps} />
          </div>,
        ]}
      </Formik>
    </>
  );
};

export default Detail;
